import {
  createFileRoute,
  Navigate,
  Outlet,
  redirect,
} from "@tanstack/react-router"

import { useAuth } from "@/store/auth"
import { Sidebar } from "@/components/navigation/sidebar"
import { StaffNav } from "@/components/navigation/staff-nav"
import { NotificationBell } from "@/features/notifications/components/notification-bell"
import { useInactivityLogout } from "@/hooks/use-inactivity-logout"

export const Route = createFileRoute("/_app")({
  component: AppLayout,
  beforeLoad: ({ context, location }) => {
    if (!context.auth.user) {
      throw redirect({
        to: "/sign-in",
        search: {
          // Use the current location to power a redirect after login
          // (Do not use `router.state.resolvedLocation` as it can
          // potentially lag behind the actual current location)
          redirect: location.href,
        },
      })
    }
  },
})

function AppLayout() {
  const { user } = useAuth()
  useInactivityLogout()

  return (
    <div className="flex h-dvh w-full">
      <Sidebar />
      <div className="flex flex-1 flex-col overflow-hidden">
        <header className="flex h-16 w-full items-center justify-end gap-4 border-b px-4 md:px-6">
          <NotificationBell />
          <StaffNav />
        </header>
        <main className="flex-1 overflow-auto bg-gray-100 px-4 md:px-5">
          {user ? (
            <Outlet />
          ) : (
            <>
              <Navigate to={"/sign-in"} />
              <Outlet />
            </>
          )}
        </main>
      </div>
    </div>
  )
}
